var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-aos":"fade-up"}},[_c('h2',{staticClass:"primary--text"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"pt-2 pb-5"},[_vm._v(_vm._s(_vm.dateCreated))]),_c('v-img',{attrs:{"src":_vm.backgroundImage}}),_c('p',{class:[{ 'line-clamp-6': !_vm.toggle }, 'pt-5 text-justify'],domProps:{"innerHTML":_vm._s(_vm.description)}}),_c('router-link',{attrs:{"to":{
      name: 'MediaArticle',
      params: {
        id: _vm.id,
        title: _vm.formatArticleTitle(_vm.title)
      }
    }}},[_c('h3',{staticClass:"text-right font-weight-bold text-hover mb-10"},[_vm._v("Read More")])]),_c('base-horizontal-line')],1)}
var staticRenderFns = []

export { render, staticRenderFns }